import _slicedToArray from "D:/VUE\u5EB7\u4E50\u901A\u95E8\u5E97/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onMounted, onUnmounted, ref, watch, getCurrentInstance } from '../../../adapter-vue';
import { TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import { isUniFrameWork } from '../../../utils/env';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    isFetching: {
      type: Boolean,
      "default": false
    },
    isTerminateObserve: {
      type: Boolean,
      "default": false
    }
  },
  emits: ["onExposed"],
  setup: function setup(__props, _ref) {
    var _getCurrentInstance;
    var __emit = _ref.emit;
    var emits = __emit;
    var props = __props;
    var observer = null;
    var selfDomRef = ref();
    var thisInstance = ((_getCurrentInstance = getCurrentInstance()) === null || _getCurrentInstance === void 0 ? void 0 : _getCurrentInstance.proxy) || getCurrentInstance();
    onMounted(function () {
      if (props.isTerminateObserve) {
        return;
      }
      if (!isUniFrameWork) {
        observer = new IntersectionObserver(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 1),
            entry = _ref3[0];
          if (entry.isIntersecting) {
            emits('onExposed');
          }
        }, {
          threshold: 1.0
        });
        if (selfDomRef.value) {
          observer.observe(selfDomRef.value);
        }
      } else {
        observer = uni.createIntersectionObserver(thisInstance).relativeToViewport();
        observer.observe('.fetch-more-block', function () {
          emits('onExposed');
        });
      }
    });
    onUnmounted(function () {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
    });
    watch(function () {
      return props.isTerminateObserve;
    }, function (isTerminateObserve) {
      if (!observer) {
        return;
      }
      if (isTerminateObserve) {
        observer.disconnect();
      } else if (selfDomRef.value) {
        observer.disconnect();
        if (!isUniFrameWork) {
          observer.observe(selfDomRef.value);
        } else {
          observer.observe('.fetch-more-block', function () {
            emits('onExposed');
          });
        }
      }
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "selfDomRef",
        ref: selfDomRef,
        "class": "fetch-more-block"
      }, [props.isFetching ? _renderSlot(_ctx.$slots, "fetching", {
        key: 0
      }, function () {
        return [_createElementVNode("div", null, _toDisplayString(_unref(TUITranslateService).t("TUIChat.正在加载")), 1)];
      }) : _renderSlot(_ctx.$slots, "fetchEnd", {
        key: 1
      }, function () {
        return [_createElementVNode("div", null, _toDisplayString(_unref(TUITranslateService).t("TUIChat.加载结束")), 1)];
      })], 512);
    };
  }
});